import request from '@/utils/request'
// 商城接口
// 新增商品：post product/create,参数：
// title // 标题
// avatar // 封面
// imageList // 轮播图
// price // 价格
// descList // 描述参数，[{key,value}]
// text // 详情
// note // 购买须知
// tagIdList // 标签列表[tagId,]
// order // 排序
export function createProduct(data) {
    return request({
        url: '/product/create',
        method: 'post',
        data,
    })
}
// 修改商品：post product/update,参数：
// productId // 商品ID
// title // 标题
// avatar // 封面
// imageList // 轮播图
// price // 价格
// descList // 描述参数，[{key,value}]
// text // 详情
// note // 购买须知
// tagIdList // 标签列表[tagId,]
// order // 排序
export function updateProduct(data) {
    return request({
        url: '/product/update',
        method: 'post',
        data,
    })
}
// 删除商品：post product/remove,参数：
// productId // 商品ID
export function removeProduct(data) {
    return request({
        url: '/product/remove',
        method: 'post',
        data,
    })
}
// 获取单个商品：get product/find,参数：
// productId // 商品ID
export function findProduct(params) {
    return request({
        url: '/product/find',
        method: 'get',
        params,
    })
}
// 获取商品列表：get product/findList,参数：
// page
// size
// keyword // 关键词，搜索标题，详情等
export function findProductList(params) {
    return request({
        url: '/product/findList',
        method: 'get',
        params,
    })
}
// 获取所有商品：get product/findAll,参数：
// page
// size
// keyword // 关键词，搜索标题，详情等
export function findProductAll(params) {
    return request({
        url: '/product/findAll',
        method: 'get',
        params,
    })
}
// 新增商品标签：post product/createTag,参数：
// title // 标题
// icon // 图标
// order // 排序
export function createTag(data) {
    return request({
        url: '/product/createTag',
        method: 'post',
        data,
    })
}
// 修改商品标签：post product/updateTag,参数：
// productId // 商品ID
// title // 标题
// icon // 图标
// order // 排序
export function updateTag(data) {
    return request({
        url: '/product/updateTag',
        method: 'post',
        data,
    })
}
// 删除商品标签：post product/removeTag,参数：
// tagId // 商品标签ID
export function removeTag(data) {
    return request({
        url: '/product/removeTag',
        method: 'post',
        data,
    })
}
// 获取单个商品标签：get product/findTag,参数：
// tagId // 商品标签ID
export function findTag(params) {
    return request({
        url: '/product/findTag',
        method: 'get',
        params,
    })
}
// 获取商品标签列表：get product/findTagList,参数：
// page
// size
// keyword // 关键词，搜索标题
export function findTagList(params) {
    return request({
        url: '/product/findTagList',
        method: 'get',
        params,
    })
}
// 获取所有商品标签：get product/findTagAll,参数：
// page
// size
// keyword // 关键词，搜索标题
export function findTagAll(params) {
    return request({
        url: '/product/findTagAll',
        method: 'get',
        params,
    })
}
// 获取商城（小程序使用，一次返回所有标签和第一个标签的商品）：get product/findShop,参数：
// 无

//抖音落地页
export function createPage(data) {
    return request({
        url: '/product/createPage',
        method: 'post',
        data,
    })
}
export function updatePage(data) {
    return request({
        url: '/product/updatePage',
        method: 'post',
        data,
    })
}
export function removePage(data) {
    return request({
        url: '/product/removePage',
        method: 'post',
        data,
    })
}
export function findPage(params) {
    return request({
        url: '/product/findPage',
        method: 'get',
        params,
    })
}

export function findPageList(params) {
    return request({
        url: '/product/findPageList',
        method: 'get',
        params,
    })
}